export const EMPTY_MODE_PROJECTION = Object.freeze({ revision: 0, modes: [], composer_options: [] });

export const normalizeModeProjection = (value) => {
  if (!value || !Number.isInteger(value.revision) || value.revision < 0
    || !Array.isArray(value.modes) || !Array.isArray(value.composer_options)) {
    throw new Error('mode_projection_invalid');
  }
  return { ...value, modes: [...value.modes], composer_options: [...value.composer_options] };
};
